export interface Action<P> {
  type: string;
  payload: P;
  error?: boolean;
  parent?: Action<P> | null;
  showNotification?: boolean;
}

export function generalAction(type: string, result: any, rest: any): any {
  if (typeof result === 'undefined' || result === null) {
    return { type, ...rest };
  }

  return { type, result, ...rest };
}

export function createAction<P>(
  type: string,
  payload: P = {} as P,
  parent: Action<P> | null = null,
  showNotification = true
): Action<P> {
  return {
    type,
    payload,
    error: payload instanceof Error,
    parent,
    showNotification,
  };
}
